import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { Autocomplete as CoreAutocomplete } from '@mc/react-autocomplete';
import { useTheme } from '../useTheme';
import { FormItem } from './FormItem';
import classNames from 'classnames';

export type AutocompleteProps = VFFieldProps<
  React.ComponentProps<typeof CoreAutocomplete>
>;
export const Autocomplete = React.forwardRef<
  HTMLInputElement,
  AutocompleteProps
>(
  (
    { name, validate, fast, className, inputClassName, label, ...other },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FormItem
        name={name}
        className={className}
        label={label}
        required={other.required}
        disabled={other.disabled}
      >
        <Field name={name}>
          {({
            input: { value, onChange: $onChange, onBlur: $onBlur },
          }: FieldRenderProps<any>) => {
            return (
              <CoreAutocomplete
                {...other}
                className={classNames(`${ns}-autocomplete`, inputClassName)}
                onChange={(value) => {
                  $onChange({ target: { name, value } });
                  other.onChange?.({ target: { name, value } });
                }}
                onBlur={(value) => {
                  $onBlur({
                    target: { name, value },
                  } as any as React.FocusEvent<HTMLElement>);
                  other.onBlur?.({ target: { name, value } });
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
